<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="/crm/home">
                <img class="navbar-brand-full" src="img/brand/logo.svg" width="150" height="100" alt="CoreUI Logo">
                <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
            </b-link>

            <SidebarToggler class="d-md-down-none" display="lg" />

            <b-navbar-nav class="ml-auto">
                <b-nav-item >
                    <DefaultHeaderDropdown />
                </b-nav-item>
            </b-navbar-nav>

            <!-- <AsideToggler class="d-none d-lg-block" /> -->
        </AppHeader>

        <div class="app-body">
            <AppSidebar fixed>
                <SidebarHeader />
                <SidebarForm />
                <SidebarNav :navItems="navItems"></SidebarNav>
                <SidebarFooter>
                </SidebarFooter>
                <SidebarMinimizer />
            </AppSidebar>
            <main class="main">
                <!-- <Breadcrumb :list="list" /> -->

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item mt-1"><a href="crm/home" v-b-tooltip.hover title="Go to main page"><i class="fa fa-home"></i></a></li>
                        <li v-if="$route.meta.parentRoute" class="breadcrumb-item mt-1"><a :href="'#/'+ $route.meta.parentRoute.path" v-b-tooltip.hover :title="$route.meta.parentRoute.breadcrumbText">{{this.$route.meta.parentRoute.breadcrumbText}}</a></li>
                        <li class="breadcrumb-item mt-1">{{$route.meta.breadcrumbText}}<label class="m-0" v-if="order">&nbsp;{{getOrderTypeDescription(order.OrderTypeId)}}<label v-if="order.Id > 0">&nbsp;nr.&nbsp;{{order.Id}}</label></label></li>

                        <!-- Breadcrumb Menu-->
                        <li style="margin-left: auto;" class="mt-0">
                            <b-button-group size="sm" v-if="orderTypeSettingsLoaded">
                                <b-button size="sm" variant="primary" v-on:click="addCarOrder">
                                    <i class="pulse fa fa-car"></i>
                                    <span class="d-none d-sm-inline-block">
                                        &nbsp;RCA
                                    </span>
                                </b-button>
                                <b-button size="sm" variant="warning" v-on:click="addPropertyOrder">
                                    <i class="fa fa-home" />
                                    <span class="d-none d-sm-inline-block">
                                        &nbsp;Locuinta
                                    </span>
                                </b-button>
                                <b-dropdown v-if="userDefinedTypeSettings.length > 0" size="sm" variant="danger" right text="" >
                                    <div style="overflow:auto;max-height:80vh">
                                        <b-dropdown-item size="sm" v-for="(value, index)  in userDefinedTypeSettings" v-on:click="addUserDefinedOrder(value.Id)"> <i class="fa fa-plus"></i>{{value.Description}}</b-dropdown-item>
                                    </div>
                                </b-dropdown>
                            </b-button-group>
                        </li>
                    </ol>
                </nav>

                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
                <!--aside-->
                <DefaultAside />
            </AppAside>
        </div>

        <TheFooter>
            <!--footer-->
            <div>
                <a href="https://asigurarilerca.ro">&copy; 2020-2021 Popular Asig.</a>
            </div>
                <div class="ml-auto d-none d-sm-inline-block text-muted">
                    <span class="mr-1">Powered by</span>
                    <a href="https://sharpsolutions.ro" target="_blank">sharp solutions</a>
                </div>
        </TheFooter>
    </div>
</template>

<script>
    import nav from '@/_nav';
    import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue';
    import DefaultAside from './DefaultAside';
    import DefaultHeaderDropdown from './DefaultHeaderDropdown';
    import { mapGetters } from 'vuex';
    export default {
        name: 'DefaultContainer',
        components: {
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultAside,
            DefaultHeaderDropdown,
            SidebarForm,
            SidebarFooter,
            SidebarToggler,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer
        },
        data() {
            return {
                listOfOrderTypes:[],
            }
        },
        computed: {
            ...mapGetters(
                {
                    order: 'order/order',
                    orderTypeSettings: 'general/orderTypeSettings',
                    orderTypeSettingsLoaded: 'general/orderTypeSettingsLoaded',
                }),
            userDefinedTypeSettings() {
                // return only active and user defined types
                this.listOfOrderTypes = Object.values(this.orderTypeSettings);
                return this.listOfOrderTypes.filter(function (el) {
                    return  el.UserDefined == true &
                            el.IsActive == true;
                });
            },

            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched.filter((route) => route.name || route.meta.label)
            },
            navItems() {
                const userProfile = this.$store.getters['user/profile'];

                if (userProfile.IsAdmin) {
                    return nav.items.filter((item) => !item.restricted || item.restricted.indexOf('admin') >= 0);
                }

                return nav.items.filter((item) => !item.restricted);
            }
        },
        created() {

            this.$store.dispatch('general/getSettings');
            this.$store.dispatch('general/getOrderTypeSettings');
        },

        methods: {
            addCarOrder: function () {
                // if the user press again same button the form will be reloaded
                if (this.$router.currentRoute.path == '/crm/order/add/1') {

                    //this.$router.replace({path: '/order/add/1', force: true });
                    this.$router.go(this.$router.currentRoute);
                }
                else {
                    this.$router.push({ path: '/crm/order/add/1' });
                }
                
            },
            addPropertyOrder: function () {
                // if the user press again same button the form will be reloaded
                if (this.$router.currentRoute.path == '/crm/order/add/2') {
                    this.$router.go(this.$router.currentRoute);
                }
                else {
                    this.$router.push({ path: '/crm/order/add/2' });
                }
            },
            addUserDefinedOrder: function (orderTypeId) {

                if (this.$router.currentRoute.path == '/crm/order/add/'+ orderTypeId) {
                    this.$router.go(this.$router.currentRoute);
                }
                else {
                    this.$router.push({ path: '/crm/order/add/' + orderTypeId })
                }
            },
            getOrderTypeDescription: function (id) {
                const orderType = this.listOfOrderTypes.find(x => x.Id == id);
                if (orderType) {
                    return orderType.Description;
                }
                else {
                    return ''; 
                }

            }
        }
    }
</script>

